<div class="wordcloud-card">
  <div class="card-header">
    <div class="logo-wrapper">
      <img class="brand-logo" [src]="brandLogo" (error)="onImageError($event)" />
      <span class="color-dot" [style.background-color]="brandColor"></span>
    </div>
    <span class="brand-title">{{ brandName }}</span>
  </div>
  <hr class="divider" />
  <div class="card-body" [style.width.px]="chartWidth">
    <ng-container *ngIf="data?.length; else noData">
      <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions"></highcharts-chart>
    </ng-container>
    <ng-template #noData>
      <app-no-widget-data [svgSrc]="'svg/no-data-word-cloud.svg' | assetVersion"></app-no-widget-data>
    </ng-template>
  </div>
</div>